import React from "react";
import { styled } from "@mui/material/styles";
import { darkModeStepperContent } from "../../../../utils/constants";
import { useDarkModeStore } from "../../../../store/useDarkModeStore";

interface CustomStepIconProps {
    active: boolean;
    completed: boolean;
    withoutDots: boolean;
}

const getLineBackgroundColor = (activeCompleted: boolean, darkMode: boolean) => {
    if (activeCompleted) return darkMode ? "white" : "var(--color-pink)";
    return darkMode ? "#bdbdbd" : "var(--color-pink)";
};

const getCircleBackgroundColor = (activeCompleted: boolean, darkMode: boolean) => {
    if (activeCompleted) return darkMode ? "white" : "var(--color-pink)";
    return darkMode ? darkModeStepperContent : "#696CFF80";
};

const StyledStepIcon = styled("div")<{ active: boolean; completed: boolean; withoutDots: boolean }>(
    ({ active, completed, withoutDots }) => {
        const { darkMode } = useDarkModeStore();
        const activeCompleted = active || completed;

        return withoutDots
            ? {
                width: 1.5,
                height: 15,
                display: "flex",
                marginLeft: 12.5,
                marginRight: "20px",
                alignItems: "center",
                justifyContent: "center",
                opacity: activeCompleted ? 1 : 0.5,
                color: activeCompleted ? "#fff" : "#000",
                background: getLineBackgroundColor(activeCompleted, darkMode),
            }
            : {
                width: 13,
                height: 13,
                marginLeft: 7,
                display: "flex",
                borderRadius: "50%",
                alignItems: "center",
                justifyContent: "center",
                color: activeCompleted ? "#fff" : "var(--color-pink)",
                background: getCircleBackgroundColor(activeCompleted, darkMode),
                border: `${activeCompleted ? 0 : 1}px solid ${darkMode ? "#ffffff80" : "#696CFF80"}`,
            };
    }
);

const CustomStepIcon: React.FC<CustomStepIconProps> = ({ active, completed, withoutDots }) => {
    return <StyledStepIcon active={active} completed={completed} withoutDots={withoutDots} />;
};

export default CustomStepIcon;
